/*global jQuery */
/*!
* FitText.js 1.2
*
* Copyright 2011, Dave Rupert http://daverupert.com
* Released under the WTFPL license
* http://sam.zoy.org/wtfpl/
*
* Date: Thu May 05 14:23:00 2011 -0600
*/

(function( $ ){

  $.fn.fitText = function( kompressor, options ) {

    // Setup options
    var compressor = kompressor || 1,
        settings = $.extend({
          'minFontSize' : Number.NEGATIVE_INFINITY,
          'maxFontSize' : Number.POSITIVE_INFINITY
        }, options);

    return this.each(function(){

      // Store the object
      var $this = $(this);

      // Resizer() resizes items based on the object width divided by the compressor * 10
      var resizer = function () {
        $this.css('font-size', Math.max(Math.min($this.width() / (compressor*10), parseFloat(settings.maxFontSize)), parseFloat(settings.minFontSize)));
      };

      // Call once to set.
      resizer();

      // Call on resize. Opera debounces their resize by default.
      $(window).on('resize.fittext orientationchange.fittext', resizer);

    });

  };

})( jQuery );

/// website

jQuery(document).ready(function($) {

  // Global variables

  var $window = $(window);
  var $body = $('body');
  var $anchors = $('a');
  var screenSm = 768;
  // var debounceDelay = 250;
  // var throttleDelay = 250;
  

  // ===========================================================================
  //
  // Smooth scroll-to links
  // Originally from http://stackoverflow.com/a/7717572/764886
  //
  // Example markup:
  //
  // <a href="#anchor" class="scroll-to">I will scroll</a>

  var $htmlAndBody = $('html, body');
  var $smoothScrollLinks = $('[data-scroll="smooth"]');
  var scrollDuration = 500;

  $smoothScrollLinks.on('click', function (e) {
    e.preventDefault();

    $htmlAndBody.animate({
        scrollTop: $($.attr(this, 'href')).offset().top
    }, scrollDuration);
  });

  // ===========================================================================
  //
  // Open external links in new window
  // Originally from https://css-tricks.com/snippets/jquery/open-external-links-in-new-window/

  $anchors.not('a[href*="mailto"]').each(function() {
     var a = new RegExp('/' + window.location.host + '/');

     if (!a.test(this.href)) {
       $(this).on('click', function(e) {
          e.preventDefault();
          e.stopPropagation();

          window.open(this.href, '_blank');
       });
     }
  });

  

  // ===========================================================================
  // Equalizers

  // Equalize widths
  // Usage:
  // $('.equal-height').equalHeight();
  // $(window).resize(function() {
  //   $('.equal-height').css('height','auto');
  //   $('.equal-height').equalHeight();
  // });

  $.fn.equalWidth = function() {
      var maxWidth = 0;
      return this.each(function(index, box) {
          var boxWidth = $(box).width();
          maxWidth = Math.max(maxWidth, boxWidth);
      }).width(maxWidth);
  };

  // Equalize heights
  // Usage:
  // $('.equal-height').equalHeight();
  // $(window).resize(function() {
  //   $('.equal-height').css('height','auto');
  //   $('.equal-height').equalHeight();
  // });

  $.fn.equalHeight = function() {
      var maxHeight = 0;
      return this.each(function(index, box) {
          var boxHeight = $(box).height();
          maxHeight = Math.max(maxHeight, boxHeight);
      }).height(maxHeight);
  };

  // ===========================================================================
  // Navigation
  // var navTrigger = $('.js-nav-trigger');
  // var navWrapper = $('.js-nav-wrapper');
  // navWrapper.on('click touch', function(){
  //   navWrapper.toggleClass('menu-open');
  //   $('body').toggleClass('menu-open');
  // });

  // ===========================================================================
  // Messages

  var $messages = $('.message.animated');

  $messages.each(function () {
    var messageDismissStyle = $(this).attr('data-dismissable');

    $(this).on('click', function (e) {
      e.preventDefault();

      $(this)
        .addClass(messageDismissStyle)
        .delay(1000)
        .queue(function(next) {
          $(this).hide();
          next();
        });
    });
  });



  // ===========================================================================
  // Make scrolling comfortable
  //
  // http://stackoverflow.com/a/15821417

  $.fn.scrollfix = function() {
      this.bind('mousewheel DOMMouseScroll', function (e) {
          var delta = e.wheelDelta || (e.originalEvent && e.originalEvent.wheelDelta) || -e.detail,
              bottomOverflow = this.scrollTop + $(this).outerHeight() - this.scrollHeight >= 0,
              topOverflow = this.scrollTop <= 0;

          if ((delta < 0 && bottomOverflow) || (delta > 0 && topOverflow)) {
              e.preventDefault();
          }
      });
      return this;
  };

  $('.scrollfix').scrollfix();

  // ===========================================================================
  // Drawers

  var drawerToggle = $('[data-toggle="drawer"]');
  var drawer = $('.drawer');

  drawerToggle.click(function(e) {
    drawer.filter(this.hash).toggleClass('in');
    e.preventDefault();
  });


  // ===========================================================================
  // Carousel (Slick.js) initialisation

  // var $carouselSingle = $('.js-carousel-single');
  // var carouselSingleOptions = {
  //   dots: true
  // };
  

  /////////////// AKTIV CAROUSEL
  var $carouselHomeAktiv = $('.js-home-aktiv-carousel');
  var carouselHomeAktivOptions = {
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1860,
        settings: {
          dots: false,
          nav: true,
          infinite: false,
          speed: 300,
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 991,
        settings: {
          dots: false,
          nav: true,
          infinite: false,
          speed: 300,
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  };

  var $hpAktivCounter = $('.js-home-aktiv-carousel-counter');
  $carouselHomeAktiv.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide) {
    var i = (currentSlide ? currentSlide : 0) + 1;
    $hpAktivCounter.html((currentSlide + 1) + '<span class="text-gray-dark">/</span>' + slick.slideCount);

  });

  ////////////// LODGE CAROUSEL
  var $carouselLodge = $('.js-lodge-carousel');
  var carouselLodgeOptions = {
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  var $lodgeCarouselCounter = $('.js-lodge-carousel-counter-mobile');
  $carouselLodge.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide) {
    var currentIndex = (typeof currentSlide === 'undefined' ? 0 : currentSlide) + 1;
    $lodgeCarouselCounter.html(currentIndex + '<span class="text-gray">/</span>' + slick.slideCount);
});


  $('.js-lodge-before').on('click tap', function() {
    $carouselLodge.slick('slickPrev');
  });
  $('.js-lodge-after').on('click tap', function() {
    $carouselLodge.slick('slickNext');
  })

  function updateCounter(slick, currentSlide) {
    var totalSlides = slick.slideCount;

    var prevSlide = (currentSlide === 0) ? totalSlides : currentSlide;
    var nextSlide = (currentSlide === totalSlides - 1) ? 1 : currentSlide + 2;

    $('.js-lodge-prev-slide').text(prevSlide);
    $('.js-lodge-current-slide').text(currentSlide + 1); // Display as 1-based index
    $('.js-lodge-next-slide').text(nextSlide);
  }
    
  $carouselLodge.on('init', function(event, slick) {
      updateCounter(slick, 0); 
  });

  $carouselLodge.on('afterChange', function(event, slick, currentSlide) {
      updateCounter(slick, currentSlide);
  });

    


  // var $hpAktivCounter = $('.js-home-aktiv-carousel-counter');
  // $carouselHomeAktiv.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide) {
  //   var i = (currentSlide ? currentSlide : 0) + 1;
  //   $hpAktivCounter.html((currentSlide + 1) + '<span class="text-gray-dark">/</span>' + slick.slideCount);

  // });

  // js-home-aktiv-carousel-counter

  // var $carouselHomeAktiv = $('.js-home-carousel-aktiv');
  // var carouselHomeAktivOptions = {
  //   dots: false,
  //   arrows: false,
  //   infinite: true,
  //   speed: 300,
  //   slidesToShow: 2,
  //   rtl: false,
  //   slidesToScroll: 1,
  //   initialSlide: 0,
  //   responsive: [
  //     {
  //       breakpoint: 1440,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1
  //       }
  //     },
  //     {
  //       breakpoint: 992,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 1
  //       }
  //     },
  //     {
  //       breakpoint: 576,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1
  //       }
  //     }
  //   ]
  // };

  // $('.js-aktiv-previous').on('click tap', function() {
  //   $carouselHomeAktiv.slick('slickPrev');
  // });
  // $('.js-aktiv-next').on('click tap', function() {
  //   $carouselHomeAktiv.slick('slickNext');
  // })


  // apartments page carousel (listing)
  var $carouselApartments = $('.js-carousel-apartments');
  var carouselApartmentsOptions = {
    dots: false,
    nav: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '30px',
  };

  function destroyApartmentsCarousel() {
    if ($('.js-carousel-apartments').hasClass('slick-initialized')) {
      $('.js-carousel-apartments').slick('destroy');
    }      
  }

  function apartmentsCarousel() {
    if($(window).width() < 768) {
      $carouselApartments.not('.slick-initialized').slick(carouselApartmentsOptions);
    } else {
      if ( $carouselApartments.hasClass('slick-initialized') ) {
        $carouselApartments.slick('unslick');
      }
    }
  }

  var $carouselApartmentsSingle = $('.js-carousel-apartments-single');
  var carouselApartmentsSingleOptions = {
    dots: false,
    nav: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
  };

  // aktiv page carousel (listing)
  var $carouselAktiv = $('.js-carousel-aktiv');
  var carouselAktivOptions = {
    dots: false,
    nav: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    // centerMode: true,
    // centerPadding: '30px',
  };


  function aktivCarousel() {
    if($(window).width() < 768) {
      $carouselAktiv.not('.slick-initialized').slick(carouselAktivOptions);
    } else {
      if ( $carouselAktiv.hasClass('slick-initialized') ) {
        $carouselAktiv.slick('unslick');
      }
    }
  }


  // packages carousel (details 1)
  var $carouselPackages1 = $('.js-packages-carousel-1');
  var carouselPackages1Options = {
    dots: false,
    nav: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1.2,
    slidesToScroll: 1,
    // centerMode: true,
    // centerPadding: '30px',
  };

  var $carouselPackages2 = $('.js-packages-carousel-2');
  var carouselPackages2Options = {
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1.2,
    slidesToScroll: 1
  };


  function packages1Carousel() {
    if($(window).width() < 993) {
      $carouselPackages1.not('.slick-initialized').slick(carouselPackages1Options);
    } else {
      if ( $carouselPackages1.hasClass('slick-initialized') ) {
        $carouselPackages1.slick('unslick');
      }
    }
  }

  function packages2Carousel() {
    if($(window).width() < 993) {
      $carouselPackages2.not('.slick-initialized').slick(carouselPackages2Options);
    } else {
      if ( $carouselPackages2.hasClass('slick-initialized') ) {
        $carouselPackages2.slick('unslick');
      }
    }
  }

  // tabs carousel
  var $carouselTabs = $('.js-tabs-carousel');
  var carouselTabsOptions = {
    dots: false,
    nav: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    // asNavFor: '.js-tabs-carousel-nav',
    fade: true,
  };
  // tabs nav carousel
  var $carouselTabsNav = $('.js-tabs-carousel-nav');
  var carouselTabsNavOptions = {
    dots: false,
    arrows: false,
    infinite: false,
    speed: 300,
    slidesToShow: 1.5,
    slidesToScroll: 1,
    asNavFor: '.js-tabs-carousel',
    centerMode: true,
    focusOnSelect: true
    // fade: true,
  };

  // ===========================================================================
// tabs navigation
$('.js-tab-nav').on('click', function(event) {
  event.preventDefault(); 
  var index = $(this).data('index') - 1;
  console.log(index);
  $('.js-tab-nav').removeClass('active');
  $(this).addClass('active');
  $('.js-tabs-carousel').slick('slickGoTo', index);
});

// $('.js-tab-nav-dropdown').on('click', function(event) {
//   event.preventDefault(); 
//   var index = $(this).index('.js-tab-nav-dropdown');
//   $('.js-tab-nav-dropdown').removeClass('active');
//   $(this).addClass('active');
//   $('.js-tabs-carousel').slick('slickGoTo', index);
// });


  function initCarousel () {
    $carouselHomeAktiv.slick(carouselHomeAktivOptions);
    $carouselLodge.slick(carouselLodgeOptions);
    $carouselTabs.slick(carouselTabsOptions);
    $carouselTabsNav.slick(carouselTabsNavOptions);
    // $carouselHomeAktiv.slick(carouselHomeAktivOptions);
    // $carouselFullWidthHeight.slick(carouselFullWidthHeightOptions);
  }

  
  // ===========================================================================
  // apartments filtering
  // Event listener for category dropdown change
  function filterPosts() {
    // var categories = [];
    var categoriesC = [];
    var categoriesS = [];
    var categoriesF = [];
    $('.js-capacity-checkbox:checked').each(function() {
      if ($(this).is(':checked')) {
        categoriesC.push($(this).attr('rel'));
      }
    });
    $('.js-size-checkbox:checked').each(function() {
        if ($(this).is(':checked')) {
          categoriesS.push($(this).attr('rel'));
        }
    });
    $('.js-furnishing-checkbox:checked').each(function() {
      if ($(this).is(':checked')) {
        categoriesF.push($(this).attr('rel'));
      }
    });

    $.ajax({
        url: ajaxurl,
        type: 'POST',
        data: {
            action: 'filter_posts',
            categoriesC: categoriesC,
            categoriesS: categoriesS,
            categoriesF: categoriesF
        },
        success: function(response) {
            console.log(categoriesC);
            console.log(categoriesS);
            console.log(categoriesF);
            // unslick
            if ($('.js-carousel-apartments').hasClass('slick-initialized')) {
              $carouselApartments.slick('unslick');
            }
            $('#posts-container').html(response);
            // show/hide the load more button
            if (categoriesC.length || categoriesS.length || categoriesF.length) {
              $('.js-load-more-apartments').hide();
            } else {
              $('.js-load-more-apartments').show();
            }
        },
        complete: function() {
          destroyApartmentsCarousel();
          apartmentsCarousel();
        },
        error: function(xhr, status, error) {
            console.error(xhr.responseText);
        }
    });
  }

  // Trigger filtering when a checkbox is clicked
  $('.js-capacity-checkbox, .js-size-checkbox, .js-furnishing-checkbox').change(function() {
      filterPosts();
  });

  // ===========================================================================
  // Loar More Apartments
  function loadMorePosts() {
    var currentPosts = $('.apartments-item').length;
    var categories = [];
    var categoriesC = [];
    var categoriesS = [];
    var categoriesF = [];
    $('.js-capacity-checkbox:checked').each(function() {
      if ($(this).is(':checked')) {
        // categories.push($(this).attr('rel'));
        categoriesC.push($(this).attr('rel'));
      }
    });
    $('.js-size-checkbox:checked').each(function() {
        if ($(this).is(':checked')) {
          // categories.push($(this).attr('rel'));
          categoriesS.push($(this).attr('rel'));
        }
    });
    $('.js-furnishing-checkbox:checked').each(function() {
      if ($(this).is(':checked')) {
        // categories.push($(this).attr('rel'));
        categoriesF.push($(this).attr('rel'));
      }
    });

    $.ajax({
        url: ajaxurl,
        type: 'POST',
        data: {
            action: 'load_more_posts',
            categoriesC: categoriesC,
            categoriesS: categoriesS,
            categoriesF: categoriesF,
            currentPosts: currentPosts
        },
        success: function(response) {
            $('#posts-container').append(response);
            if (response.trim() === '') {
              // No more posts to load, hide the load more button
              $('.js-load-more-apartments').hide();
          }
        },
        error: function(xhr, status, error) {
            console.error(xhr.responseText);
        }
    });
  }

  // Trigger load more when load more button is clicked
  $('.js-load-more-apartments').on('click', function(e) {
    e.preventDefault();
    loadMorePosts();
  });

  // ===========================================================================
  // Bootstrap tabs update

  var tabHashPrefix = 'tab-';

  function afterTabShown(e) {  
    e.preventDefault();

    // Update location hash
    var hash = e.target.hash.substr(1);

    if (hash === '') {
      hash = $(e.target).data('target').substr(1);
    }

    window.location.hash = tabHashPrefix +  hash;
  }

  // Select tabs from on location hash

  function selectTabFromLocationHash() {
    var hash = location.hash;

    if (hash === '') {
      return;
    }

    var $tab = $anchors.filter('[href="' + hash.replace(tabHashPrefix,'') + '"]');

    // If someone uses data-target instead of href for id
    if ($tab.length === 0) {
      $tab = $anchors.filter('[data-target="' + hash.replace('tab-','') + '"]');
    }

    $tab.tab('show');
  }

  // tabs dropdown
  $('.nav-pills-selected').on('click', function() {
    var dropdown = $('.nav-pills-dropdown');
    if ($(this).hasClass('open')) {
        dropdown.slideUp();
        $(this).removeClass('open');
    } else {
        dropdown.slideDown();
        $(this).addClass('open');
    }
  });
  $('.nav-pills-dropdown a').on('click', function() {
    var newText = $(this).text();
    $('.nav-pills-selected span').text(newText);
  });
  function addText() {
    var text = $('.nav-pills-dropdown a.active').text();
    $('.nav-pills-selected span').text(text);
  }

    // load more gallery and filtering
    var startIndex = 8;
    var currentFilter = 'alle';
    
    // Initially hide all images except the first four
    $('.gallery__list-item').slice(8).hide();
    if ($('.gallery__list-item').length <= 8) {
      $('.js-load-more-gallery').hide();
  }
    
    // Handle filter clicks
    $('.js-gallery-filter').on('click', function(e) {
        // Remove the active class from all filters
        e.preventDefault();
        $('.js-gallery-filter').removeClass('active');
        
        // Add the active class to the clicked filter
        $(this).addClass('active');
    
        var filter = $(this).data('filter');
        var $galleryList = $('.gallery__list');
        var $images = $galleryList.find('.gallery__list-item');
    
        // Hide all images
        $images.hide();
    
        // Reset startIndex
        startIndex = 8;
  
        if (filter === 'alle') {
            // Show all images
            $images.slice(0, startIndex).fadeIn();
            secondItemClass()
        } else {
            // Show the first four images related to the filter
            $images.filter('[data-filter-tag="' + filter + '"]').slice(0, startIndex).fadeIn();
            secondItemClass()
        }

    
    
        // Update current filter
        currentFilter = filter;
    
        // Show or hide load more button based on the number of images related to the filter
        if (filter === 'alle') {
            if (startIndex >= $images.length) {
                $('.js-load-more-gallery').hide();
            } else {
                $('.js-load-more-gallery').show();
            }
        } else {
            if ($images.filter('[data-filter-tag="' + filter + '"]').length <= 8) {
                $('.js-load-more-gallery').hide();
            } else {
                $('.js-load-more-gallery').show();
            }
        }
    });
    
    // Handle "Load More" click event
    $('.js-load-more-gallery').on('click', function() {
        var $galleryList = $('.gallery__list');
        var $images = $galleryList.find('.gallery__list-item');
        var endIndex = startIndex + 8;
  
        // Filter images based on the current filter
        var $filteredImages = currentFilter === 'alle' ? $images : $images.filter('[data-filter-tag="' + currentFilter + '"]');
        $filteredImages.slice(startIndex, endIndex).fadeIn();
        secondItemClass()
        startIndex = endIndex;
    
        if (startIndex >= $filteredImages.length) {
            $('.js-load-more-gallery').hide();
        }
    });

    function secondItemClass() {
      const elements = document.querySelectorAll('.gallery__list-item');
  
      // Filter out elements with display: none
      const visibleElements = Array.from(elements).filter(element => window.getComputedStyle(element).display !== 'none');
  
      // Add class to every second visible element
      visibleElements.forEach((element, index) => {
          if ((index + 1) % 2 !== 0) {
              element.classList.add('itemTopOffset');
          } else {
              element.classList.remove('itemTopOffset');
          }
      });
  }
    secondItemClass()

    // gallery mobile filters (also added on tabs)
    $('.gallery__dropdown .dropdown-item').on('click', function(e) {
      e.preventDefault();
      var selectedText = $(this).text();
      $(this).closest('.dropdown').find('.dropdown-toggle').text(selectedText);
    });
  

  
// Handle aktiv filters
$('.js-aktiv-fiter').on('click', function(e) {
  e.preventDefault();

  var clickedFilter = $(this).data('filter');

  // Toggle the active class for the clicked filter
  if (clickedFilter === 'alle') {
      // If "Alle" filter is clicked, deactivate all other filters
      $('.js-aktiv-fiter').removeClass('active');
      $(this).addClass('active');
  } else {
      var activeClass = '';
      if($(this).hasClass('active')) {
        activeClass = '';
      } else {
        activeClass = 'active';
      }
      $('.js-aktiv-fiter').removeClass('active');
      if(activeClass)  {
        $(this).addClass('active');
      } else {
        $(this).removeClass('active');
      }
  }

  if ($(window).width() > 767) {

  var filters = []; // Array to store active filters
  $('.js-aktiv-fiter.active').each(function() {
      var filterValue = $(this).data('filter');
      if (filterValue !== 'alle') {
          filters.push(filterValue);
      }
  });

  var $aktivList = $('.aktiv__list');
  var $aktiv = $aktivList.find('.aktiv-item');

  // If "Alle" filter is selected or all other filters are deselected, show all posts
  if (filters.length === 0 || filters.includes('alle')) {
      $('.alle').addClass('active');
      $aktiv.fadeIn();
      secondItemClassAktiv();
      return; // Exit the function
  }

  // Hide all aktiv
  $aktiv.hide();

  // Show posts that match any of the selected filters
  $aktiv.each(function() {
      var postFilters = $(this).data('filter-tag').split(','); // Get filters for current post
      var match = filters.some(function(filter) {
          return postFilters.includes(filter.trim());
      });
      if (match) {
          $(this).fadeIn();
      }
  });
  secondItemClassAktiv();

  // Update current filter
  currentFilter = filters.join(',');

} else {
  // mobile logic
  var $aktivList = $('.aktiv__list');
  var $aktiv = $aktivList.find('.aktiv-item');
  var mobileFilter = $('.js-aktiv-fiter.active').data('filter');

  if(!mobileFilter || mobileFilter === 'alle') {
    $('.alle').addClass('active');
    $(".js-carousel-aktiv").slick('slickUnfilter');
  } else {
    $(".js-carousel-aktiv").slick('slickUnfilter').slick('slickFilter', function(index, slide) {
      var $slide = $(slide);
      var match = false;

      // Loop through each .aktiv-item within the slide
      $slide.find('.aktiv-item').each(function() {
          var postFilters = $(this).data('filter-tag').split(',');

          // Check if mobileFilter exactly matches the data-filter-tag
          if (postFilters.includes(mobileFilter)) {
              match = true; // If there's a match, set match to true
              return false; // Break the loop early since a match is found
          }
      });

      return match; // Show the slide if there's a match, otherwise it will be hidden
  });
  }
   
  $(".js-carousel-aktiv").slick('slickGoTo', 0);
}
});
  function secondItemClassAktiv() {
    const elements = document.querySelectorAll('.aktiv__list .aktiv-item');

    // Filter out elements with display: none
    const visibleElements = Array.from(elements).filter(element => window.getComputedStyle(element).display !== 'none');

    // Add class to every second visible element
    visibleElements.forEach((element, index) => {
        if ((index + 1) % 2 === 0) {
            element.classList.add('itemAktivTopOffset');
        } else {
            element.classList.remove('itemAktivTopOffset');
        }
    });
}
  secondItemClassAktiv();


  $("[data-fancybox]").fancybox({
    backFocus: false,
  }); 

//============================================================================
// Gallery load more
// load more gallery and filtering
var startIndex = 8;
var currentFilter = 'alle';

// Initially hide all images except the first four
$('.gallery__list-item').slice(8).hide();
if ($('.gallery__list-item').length <= 8) {
  $('.js-load-more-gallery').hide();
}

// Handle filter clicks
$('.js-gallery-filter').on('click', function(e) {
    // Remove the active class from all filters
    e.preventDefault();
    $('.js-gallery-filter').removeClass('active');
    
    // Add the active class to the clicked filter
    $(this).addClass('active');

    var filter = $(this).data('filter');
    var $galleryList = $('.gallery__list');
    var $images = $galleryList.find('.gallery__list-item');

    // Hide all images
    $images.hide();

    // Reset startIndex
    startIndex = 8;

    if (filter === 'alle') {
        // Show all images
        $images.slice(0, startIndex).fadeIn();
        secondItemClass()
    } else {
        // Show the first four images related to the filter
        $images.filter('[data-filter-tag="' + filter + '"]').slice(0, startIndex).fadeIn();
        secondItemClass()
    }



    // Update current filter
    currentFilter = filter;

    // Show or hide load more button based on the number of images related to the filter
    if (filter === 'alle') {
        if (startIndex >= $images.length) {
            $('.js-load-more-gallery').hide();
        } else {
            $('.js-load-more-gallery').show();
        }
    } else {
        if ($images.filter('[data-filter-tag="' + filter + '"]').length <= 8) {
            $('.js-load-more-gallery').hide();
        } else {
            $('.js-load-more-gallery').show();
        }
    }
  });

  // Handle "Load More" click event
  $('.js-load-more-gallery').on('click', function(e) {
      var $galleryList = $('.gallery__list');
      var $images = $galleryList.find('.gallery__list-item');
      var endIndex = startIndex + 8;

      e.preventDefault();
      // Filter images based on the current filter
      var $filteredImages = currentFilter === 'alle' ? $images : $images.filter('[data-filter-tag="' + currentFilter + '"]');
      $filteredImages.slice(startIndex, endIndex).fadeIn();
      secondItemClass()
      startIndex = endIndex;

      if (startIndex >= $filteredImages.length) {
          $('.js-load-more-gallery').hide();
      }
  });


// ===========================================================================
// animations
function animation() {
  $('.animate--base').each(function() {
    var controller = new ScrollMagic.Controller();
    new ScrollMagic.Scene({
      triggerElement: this,
      triggerHook: .9,
      offset: 0, // move trigger to center of element
      reverse: false // only do once
    })
    .setClassToggle(this, "visible") // add class toggle
    // .addIndicators() // add indicators (requires plugin)
    .addTo(controller);
  });
}


// ===========================================================================
// Custom nukber input icons
// $('.js-number-up').on('click', function() {
//   var input = $(this).siblings('input[type="number"]');
//   input.val(parseInt(input.val(), 10) + 1);
// });

$('.form-group').on('click', '.js-number-up', function() {
  var input = $(this).siblings('input[type="number"]');
  var currentValue = parseInt(input.val(), 10);
  var maxValue = parseInt(input.attr('max'), 10);
  
  if (isNaN(currentValue)) {
    currentValue = 0; // Default to 0 if the value is NaN
  }
  if (!isNaN(maxValue) && currentValue >= maxValue) {
    input.val(maxValue); // Prevent going above max value
  } else {
    input.val(currentValue + 1);
  }
});

$('.form-group').on('click', '.js-number-down', function() {
  var input = $(this).siblings('input[type="number"]');
  var currentValue = parseInt(input.val(), 10);
  var minValue = parseInt(input.attr('min'), 10);

  if (isNaN(currentValue)) {
    currentValue = 0; // Default to 0 if the value is NaN
  }
  if (!isNaN(minValue) && currentValue <= minValue) {
    input.val(minValue); // Prevent going below min value
  } else {
    input.val(currentValue - 1);
  }
});

// $('.js-number-down').on('click', function() {
//   var input = $(this).siblings('input[type="number"]');
//   input.val(parseInt(input.val(), 10) - 1);
// });

// ===========================================================================
// Navigation (transparent above featured image, white bg below)

function navBg() {
  var projectsNav = $('.single-projects_type'),
  headerHeight = $('.js-hero').height();

  var controllerNav = new ScrollMagic.Controller({globalSceneOptions: {duration: headerHeight}});
  // var triggerHook = scene.triggerHook();
  new ScrollMagic.Scene({triggerElement: ".js-hero", triggerHook: 0})
      .setClassToggle(".faktotum-auto-hide-header", "no-bg") // add class toggle
      // .addIndicators() // add indicators (requires plugin)
      .addTo(controllerNav);
}

  // replace dropdown blank field
  $('.post-dropdown select option:first-child').text('Appartment');

  // Detect Bootstrap tab shown event
  $('[data-toggle="tab"]').on('shown.bs.tab', afterTabShown);

  /**
   * Initialization
   */
  var init = function () {
    selectTabFromLocationHash();
    // handleBreadcrumbs();
    initCarousel();
    apartmentsCarousel();
    $carouselApartmentsSingle.slick(carouselApartmentsSingleOptions);
    aktivCarousel();
    packages1Carousel();
    packages2Carousel();
    addText();
    animation();
    navBg();
  };

  var onResize = function () {
    // handleBreadcrumbs();
    apartmentsCarousel();
    aktivCarousel();
    packages1Carousel();
    packages2Carousel();
  };

  var onScroll = function () {
  };

  $window.on('resize', onResize);

  // $window.on('scroll', $.throttle(throttleDelay, onScroll));


  // fittext
  $('.js-home-simple-content').fitText(0.7);
  $('.js-editable-content-element-item').fitText(1);
  $('.js-fluid-bars-text').fitText(2.75);

  init();

});
